<template>
  <popup :showFlag="showFlag"
         @onShowpop="onShowpop">
    <div class="se_wrap">
      <img src="@/assets/icon_del.png" class="se_del" @click="onShowpop"/>
      <div class="se_savewaywrap">
        <div v-show="extract_str"
             class="se_waylist"
             :class="[wayidx === 1 ? 'activeway' : '']"
             @click.stop="selway(1)">
          <img :src="require(wayidx === 1 ? './img/a_comp.png' : './img/comp.png')" class="se_img"/>
          <div class="se_txt">提取码提取</div>
        </div>
        <div class="se_waylist"
             :class="[wayidx === 2 ? 'activeway' : '']"
             @click.stop="selway(2)">
          <img :src="require(wayidx === 2 ? './img/a_email.png' : './img/email.png')" class="se_img"/>
          <div class="se_txt">发送至邮箱</div>
        </div>
      </div>
      <!-- <div class="se_detail" v-show="wayidx === 0">
        <div class="infowrap">
          <img src="./img/zhuyi.png" class="se_zhuyi"/>
          直接保存至手机会对照片进行压缩哦（影响照片分辨率）
        </div>
        <div class="se_saveBtn"
             @click.stop="savephone">保存到手机相册
        </div>
      </div> -->
      <div class="se_detail" v-show="wayidx === 1">
        <div class="infowrap">
          <img src="./img/zhuyi.png" class="se_zhuyi" />
          请在“电脑浏览器”中打开网址提取证件照
        </div>
        <div class="tiquma">
          <div class="tqmlist">
            下载地址
            <div class="tmqval">
              {{downurl}}
            </div>
          </div>
          <div class="tqmlist">
            提取码
            <div class="tmqval">
              {{extract_str}}
            </div>
          </div>
        </div>
        <div class="se_saveBtn"
             @click.stop="rf"
             v-clipboard:copy="'下载地址:'+downurl+'\n提取码:'+extract_str"
             v-clipboard:success="onCopy"
             v-clipboard:error="onError">复制网址及提取码
        </div>
      </div>
      <div class="se_detail" v-show="wayidx === 2">
        <div class="infowrap">
          <img src="./img/zhuyi.png" class="se_zhuyi"/>
          为了保证照片能正常发送，请输入有效的邮箱地址
        </div>
        <div class="tiquma">
          <div class="iptlist">
            *电子邮箱
            <input @blur="upkeyboard" name="email" v-model="email" class="seipt" placeholder="请输入您的邮箱" />
          </div>
          <div class="iptlist">
            文件名
            <input @blur="upkeyboard" name="filename" v-model="filename" class="seipt" placeholder="请为照片命名" />
          </div>
          <div class="iptlist">
            主题
            <input @blur="upkeyboard" name="theme" v-model="theme" class="seipt" placeholder="请输入您的邮件主题" />
          </div>
          <textarea @blur="upkeyboard" class="dettxt" v-model="detail" name="detail" placeholder="请输入您的邮件正文"  />
        </div>
        <button @click.stop="onSubmit" class="se_saveBtn emailbtn">
        发送至指定邮箱
        </button>
      </div>
    </div>
  </popup>
</template>

<script>
import popup from '../popup'
import { Toast, MessageBox } from 'mint-ui'
import { mapState, mapActions, mapMutations } from 'vuex'
import { upkeyboard } from '@/utils/utils'
export default {
  name: 'saveEle',
  props: {
    showFlag: {
      default: false,
      type: Boolean
    },
    printName: {
      default: () => [],
      type: Array
    },
    finalName: {
      default: () => [],
      type: Array
    },
    isCollect: {
      default: false,
      type: Boolean
    },
    isVisible: {
      default: false,
      type: Boolean
    },
    orderid: {
      default: '',
      type: String
    },
    savephoto: {
      default: false,
      type: Boolean
    },
    downurl: {
      default: 'www.id-photo-verify.com/t',
      type: String
    },
    extract_str: {
      default: '',
      type: String
    }
  },
  data () {
    return {
      wayidx: 0,
      email: '',
      filename: '',
      theme: '',
      detail: ''
    }
  },
  components: {
    popup
  },
  created () {
    this.saveEleShow()
  },
  methods: {
    ...mapActions(['sendEmailA', 'ownerEmailA']),
    ...mapMutations(['setLoadingTxt']),
    saveEleShow () {
      const { extract_str, savephoto } = this
      this.wayidx = !this.isIos && savephoto ? 0 : extract_str ? 1 : 2
      console.log('wayidx:::', this.wayidx)
    },
    upkeyboard () {
      upkeyboard()
    },
    rf () {
      return false
    },
    onShowpop () {
      const { extract_str, savephoto } = this
      this.wayidx = !this.isIos && savephoto ? 0 : extract_str ? 1 : 2
      this.$emit('onCloseEleSave')
    },
    onCopy () {
      Toast({
        message: '复制成功',
        duration: 2000
      })
    },
    selway (idx) {
      idx = +idx
      const { wayidx } = this
      if (wayidx !== idx) {
        this.wayidx = idx
      }
    },
    onError () {
      Toast({
        message: '复制失败，请重新尝试',
        duration: 2000
      })
    },
    savephone () {
      console.log('保存图片')
    },
    onSubmit () {
      let { detail, email, filename, theme, isCollect, isVisible, orderid } = this
      email = email.trim() // 去掉前后空格
      const reg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
      if (email === undefined || email === '') {
        MessageBox.alert('请输入邮箱')
        return
      }
      if (!reg.test(email)) {
        MessageBox.alert('邮箱格式不正确')
        return
      }
      const data = {
        ...isCollect && { type: 1 },
        ...!isVisible && { order_id: orderid },
        ...isVisible && { project_no: orderid },
        email,
        ...filename && {
          file_name: filename
        },
        ...theme && {
          subject: theme
        },
        ...detail && {
          content: detail
        }
      }
      const fnname = isVisible ? this.ownerEmailA : this.sendEmailA
      fnname(data).then(res => {
        const { result } = res
        this.email = ''
        this.filename = ''
        this.theme = ''
        this.detail = ''
        this.$emit('onSavesuccess')
        Toast(result)
      })
    }
  },
  computed: {
    ...mapState(['isIos', 'actiBol'])
  }
}
</script>

<style scoped>
.se_wrap{
  border-top-left-radius: .32rem;
  border-top-right-radius: .32rem;
  background-color: white;
  box-sizing: border-box;
  padding:1.12rem .6rem .35rem;
  position: relative;
}
.order2{
  order:2
}
.se_del{
  width:.42rem;
  border:.1rem solid transparent;
  position: absolute;
  right:.24rem;
  top:.24rem;
}
.se_savewaywrap{
  display: flex;
  display: -webkit-flex;
  justify-content: space-around;
  font-size: .26rem;
  color:#606266;
  margin-bottom: .32rem;
}
.se_waylist{
  flex-shrink: 0;
  width:1.92rem;
  height:1.92rem;
  box-sizing: border-box;
  border-radius: .16rem;
  border:.04rem solid transparent;
  display: flex;
  display: -webkit-flex;
  align-content: center;
  justify-content: center;
  flex-wrap: wrap;
  background-color: #F5F7FA;
}
.se_img{
  width:.64rem;
  height:.64rem;
  margin-bottom: .16rem;
  flex-shrink: 0;
}
.se_txt{
  flex-basis: 100%;
  text-align: center;
}
.activeway{
  border-color:#4710ED;
  background-color: white;
  color:#4710ED;
}
.infowrap{
  display: flex;
  display: -webkit-flex;
  align-items: center;
  font-size: .24rem;
  color:#303133;
  white-space: nowrap;
  height:.4rem;
  line-height: .4rem;
}
.se_zhuyi{
  width:.32rem;
  margin-right: .16rem;
  flex-shrink: 0;
  vertical-align: middle;
}
.se_saveBtn{
  width:100%;
  height:.88rem;
  border-radius: .12rem;
  background-color: #4710ED;
  font-size: .34rem;
  color:white;
  text-align: center;
  line-height: .88rem;
  margin-top: .9rem;
  border:none;
}
.active_sebtn{
  background-color: rgba(71, 16, 237, 0.6);
}
.tiquma{
  border-top:.02rem solid #E5E5EA;
  margin-top: .32rem;
  padding-top: .3rem;
  font-size: .28rem;
  color:#303133;
}
.tqmlist,.iptlist{
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: space-between;
}
.iptlist{
  margin-bottom: .13rem;
}
.tqmlist:first-child{
  margin-bottom: .26rem;
}
.tmqval{
  flex-shrink: 0;
  font-size: .26rem;
}
.seipt{
  border: none;
  font-size: .26rem;
  color:#303133;
  text-align: right;
  flex-grow: 1;
}
.dettxt{
  display: block;
  width: 100%;
  border:none;
  resize: none;
  background-color: #F5F7FA;
  font-size: .26rem;
  color:#303133;
  line-height: .38rem;
  box-sizing: border-box;
  padding:.32rem;
  height:1.92rem;
}
.emailbtn{
  margin-top: .4rem;
}
</style>
